type SessionReason = 'expired' | 'invalid';

type SessionListener = (reason: SessionReason) => void;

const sessionListeners = new Set<SessionListener>();
let openAuthModal: (() => void) | null = null;

export function onAuthSessionRequired(listener: SessionListener) {
  sessionListeners.add(listener);
  return () => { sessionListeners.delete(listener); };
}

export function emitAuthSessionRequired(reason: SessionReason = 'expired') {
  sessionListeners.forEach((listener) => listener(reason));
}

export function registerAuthModalOpener(opener: () => void) {
  openAuthModal = opener;
  return () => {
    if (openAuthModal === opener) openAuthModal = null;
  };
}

export function requestOpenAuthModal() {
  openAuthModal?.();
}
